// extracted by mini-css-extract-plugin
export default {"content":"styles_content__FQFmT","pendingWrapper":"styles_pendingWrapper__CfB1e","detailsContent":"styles_detailsContent__gLty3"};